interface BlockQuoteProps extends React.HTMLAttributes<HTMLQuoteElement> {}

export default function BlockQuote({ className, ...props }: BlockQuoteProps) {
  return (
    <blockquote
      className={[
        'article-breakout relative my-8 pr-10 pl-12 lg:my-12',
        // Add a left-facing quotation mark before the blockquote content
        "before:absolute before:top-[-15px] before:right-[calc(100%-40px)] before:content-['“'] lg:before:top-[-25px]",
        'before:font-display before:text-[64px]/[1.2] before:font-medium before:text-green-50 lg:before:text-[96px]/[1.2]',
        // Markdown blockquotes render nested <p>; style that content directly.
        '[&_p]:font-display [&_p]:mb-0 [&_p]:text-[36px]/[1.2] [&_p]:font-bold [&_p]:text-green-50 [&_p]:lg:text-[48px]/[1.2]',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      {...props}
    />
  );
}
